module.exports = __webpack_public_path__ + "img/icon_textSolid.9152fdaa.svg";